var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "context/ThemeContext";
import { Button, ButtonPropTypes } from "./Button";
var PrimaryButton = function (_a) {
    var disabled = _a.disabled, inValid = _a.inValid, _b = _a.style, style = _b === void 0 ? {} : _b, resProps = __rest(_a, ["disabled", "inValid", "style"]);
    var theme = useTheme().theme;
    var primaryStyle = __assign({ opacity: disabled || inValid ? "65%" : undefined, backgroundColor: theme.primaryColor, color: "#fff" }, style);
    return _jsx(Button, __assign({}, resProps, { style: primaryStyle, disabled: disabled }));
};
PrimaryButton.propTypes = ButtonPropTypes;
export default PrimaryButton;
